export default "__VITE_ASSET__BL70ORYM__"